import { types, type Instance } from 'mobx-state-tree';

const Email = types
  .model('Email', {
    id: types.identifier,
    subject: types.optional(types.string, ''),
    message: types.optional(types.string, ''),
    sentDate: types.optional(types.string, ''),
    from: types.optional(types.string, ''),
    to: types.optional(types.string, ''),
    isNew: types.optional(types.boolean, false),
  })
  .actions((self) => {
    const markedAsNotNew = () => {
      self.isNew = false;
    };

    return {
      markedAsNotNew,
    };
  });

export interface IEmail extends Instance<typeof Email> {}

export default Email;
